// Vérification MX courriel (appelle /verify-email).

import { S } from './state.js';
import { $, clearE } from './dom.js';
import { apiGet } from './api.js';
import { EMAIL_RE } from './config.js';

export function verifyEmailMX( email ) {
	if ( ! email || ! EMAIL_RE.test( email ) ) return;
	var spin   = $( 'emailMXSpinner' );
	var status = $( 'emailMXStatus' );
	var msg    = $( 'emailMXMsg' );
	var fr     = S.lang === 'fr';

	if ( spin )   spin.style.display   = 'inline';
	if ( status ) status.style.display = 'none';
	if ( msg )    msg.style.display    = 'none';
	S.emailVerified = false;

	apiGet( 'verify-email', { email: email } )
		.then( function ( res ) {
			if ( spin ) spin.style.display = 'none';
			var ok = res && res.data && res.data.valid;
			if ( ok ) {
				if ( status ) { status.textContent = '✅'; status.style.display = 'inline'; }
				if ( msg ) msg.style.display = 'none';
				S.emailVerified = true;
				clearE( 'f-email' );
			} else {
				if ( status ) { status.textContent = '❌'; status.style.display = 'inline'; }
				if ( msg ) {
					msg.textContent = fr
						? ( ( res.data && res.data.reason )    || 'Ce domaine ne semble pas recevoir de courriels.' )
						: ( ( res.data && res.data.reason_en ) || 'This domain does not appear to accept emails.' );
					msg.style.display = 'block';
				}
				$( 'f-email' ).classList.add( 'err' );
				S.emailVerified = false;
			}
		} )
		.catch( function ( e ) {
			if ( spin ) spin.style.display = 'none';
			S.emailVerified = true; // silent fail — on ne bloque pas le client
			console.warn( 'Email MX verify error:', e );
		} );
}
